import { render, staticRenderFns } from "./validation-data-table.vue?vue&type=template&id=02895cfe&scoped=true"
import script from "./validation-data-table.vue?vue&type=script&lang=js"
export * from "./validation-data-table.vue?vue&type=script&lang=js"
import style0 from "./validation-data-table.vue?vue&type=style&index=0&id=02895cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02895cfe",
  null
  
)

export default component.exports